import React from 'react';

const countries = [
  { c: 'ae', n: 'UAE' },
  { c: 'sa', n: 'Saudi Arabia' },
  { c: 'om', n: 'Oman' },
  { c: 'ir', n: 'Iran' },
  { c: 'ke', n: 'Kenya' },
  { c: 'tz', n: 'Tanzania' },
  { c: 'ng', n: 'Nigeria' },
  { c: 'gh', n: 'Ghana' },
  { c: 'ci', n: "Côte d'Ivoire" },
  { c: 'my', n: 'Malaysia' },
  { c: 'ph', n: 'Philippines' },
  { c: 'cn', n: 'China' },
  { c: 'sg', n: 'Singapore' },
  { c: 'nl', n: 'Netherlands' },
  { c: 'gb', n: 'United Kingdom' },
  { c: 'de', n: 'Germany' },
  { c: 'ca', n: 'Canada' },
];

const stats = [
  '30+ Countries Served',
  '7,000 MT / Month Capacity',
  'FOB Port Qasim, Karachi',
  '25+ Years Exporting',
];

const Dot = () => <span className="w-1 h-1 rounded-full bg-ktc-gold/50 shrink-0" />;

const Track = ({ hidden }) => (
  <div className="flex items-center gap-8 shrink-0 pr-8" aria-hidden={hidden}>
    {countries.map((x) => (
      <div key={x.c} className="flex items-center gap-2.5 shrink-0">
        <img
          src={`https://flagcdn.com/w40/${x.c}.png`}
          alt={x.n}
          loading="lazy"
          className="h-3.5 w-5 object-cover rounded-[2px] shadow-sm ring-1 ring-black/5"
        />
        <span className="text-[13px] font-medium text-ktc-green tracking-wide whitespace-nowrap">{x.n}</span>
        <Dot />
      </div>
    ))}
    {stats.map((s) => (
      <div key={s} className="flex items-center gap-2.5 shrink-0">
        <span className="text-[13px] font-semibold text-ktc-gold uppercase tracking-[0.14em] whitespace-nowrap">{s}</span>
        <Dot />
      </div>
    ))}
  </div>
);

const TrustStrip = () => (
  <section
    data-testid="trust-strip"
    className="bg-ktc-ivoryLight border-b border-ktc-cream overflow-hidden relative"
  >
    <div className="pointer-events-none absolute inset-y-0 left-0 w-20 z-10 bg-gradient-to-r from-ktc-ivoryLight to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-20 z-10 bg-gradient-to-l from-ktc-ivoryLight to-transparent" />
    <div className="flex items-center py-3.5 marquee-track">
      <Track />
      <Track hidden />
    </div>
  </section>
);

export default TrustStrip;
